document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('meal-search');
  const resultsCount = document.getElementById('results-count');
  const allMealCardGrids = document.querySelectorAll('.meals-list-with-search__meal-cards-grid');
  const firstMealCardsGrid = allMealCardGrids[0]; // First list section grid
  const otherMealCardGrids = Array.from(allMealCardGrids).slice(1); // All grids except the first
  const collectionSection = document.getElementById('our-meals-collection');
  const pagination = collectionSection ? collectionSection.querySelector('[data-meals-pagination]') : null;
  const collectionHandle = collectionSection ? collectionSection.getAttribute('data-collection-handle') : '';
  const collectionUrl = collectionSection ? collectionSection.getAttribute('data-collection-url') : '';
  const originalGridHTML = firstMealCardsGrid ? firstMealCardsGrid.innerHTML : '';
  let allCollectionProductsPromise = null;

  if (!searchInput || !resultsCount || !firstMealCardsGrid) return;

  // Function to move all meal cards to the first grid and hide other sections
  function consolidateMealCards() {
    otherMealCardGrids.forEach((grid) => {
      while (grid.children.length > 0) {
        firstMealCardsGrid.appendChild(grid.children[0]); // Move the first child until grid is empty
      }
      grid.closest('.meals-list-with-search').style.display = 'none'; // Hide the parent section
    });
  }

  // Call the consolidateMealCards function
  consolidateMealCards();

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatTypeBadge(tags) {
    const tagList = Array.isArray(tags) ? tags : String(tags || '').split(',');
    const typeTag = tagList.find((tag) => tag.trim().toLowerCase().startsWith('type::'));

    if (!typeTag) return '';

    const typeValue = typeTag
      .split('::')
      .slice(1)
      .join('::')
      .trim()
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .toLowerCase();

    return typeValue ? typeValue.charAt(0).toUpperCase() + typeValue.slice(1) : '';
  }

  function buildMealCard(product) {
    const title = escapeHtml(product.title);
    const image = product.images && product.images.length ? product.images[0].src : '';
    const productUrl = collectionUrl ? `${collectionUrl}/products/${product.handle}` : `/products/${product.handle}`;
    const typeBadge = escapeHtml(formatTypeBadge(product.tags));
    const arrowIcons = `
      <svg class="svg-black" width="25" height="15" viewBox="0 0 25 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.8062 13.2959L23.3921 7.36859L16.8062 1.44128" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 6.36865C0.447715 6.36865 0 6.81637 0 7.36865C0 7.92094 0.447715 8.36865 1 8.36865V6.36865ZM23.3921 6.36865H1V8.36865H23.3921V6.36865Z" fill="black" />
      </svg>
      <svg class="svg-grey" width="25" height="15" viewBox="0 0 25 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.8062 13.2959L23.3921 7.36859L16.8062 1.44128" stroke="#767573" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 6.36865C0.447715 6.36865 0 6.81637 0 7.36865C0 7.92094 0.447715 8.36865 1 8.36865V6.36865ZM23.3921 6.36865H1V8.36865H23.3921V6.36865Z" fill="#767573" />
      </svg>
    `;
    const titleWords = title.split(' ');
    const lastWord = titleWords.pop();
    const titleMarkup = `${titleWords.join(' ')}${titleWords.length ? ' ' : ''}<span class="meal-card-title__nowrap">${lastWord}&nbsp;${arrowIcons}</span>`;

    return `
      <a href="${productUrl}" class="meal-card-link" data-title="${title}">
        <div class="meal-card">
          <div class="meal-image-container">
            ${
              image
                ? `<img src="${image}" alt="${title}" class="meal-image" loading="lazy">`
                : `<svg class="meal-image placeholder-svg" viewBox="0 0 525.5 525.5" role="img" aria-label="${title}"></svg>`
            }
            <div class="hover-overlay">See more</div>
            ${typeBadge ? `<div class="meal-card-badge">${typeBadge}</div>` : ''}
          </div>
          <div class="meal-card-title">
            ${titleMarkup}
          </div>
        </div>
      </a>
    `;
  }

  async function fetchCollectionProducts() {
    if (!collectionHandle) return [];
    if (allCollectionProductsPromise) return allCollectionProductsPromise;

    allCollectionProductsPromise = (async function () {
      const products = [];
      let page = 1;
      const limit = 250;

      while (true) {
        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=${limit}&page=${page}`);
        if (!response.ok) {
          throw new Error('Unable to fetch collection products');
        }

        const data = await response.json();
        const pageProducts = data.products || [];
        products.push(...pageProducts);

        if (pageProducts.length < limit) break;
        page += 1;
      }

      return products;
    })();

    return allCollectionProductsPromise;
  }

  function updateResultsCount(keyword, count) {
    resultsCount.textContent = keyword ? `Showing ${count} results for "${keyword}"` : 'All results';
  }

  function restorePaginatedResults() {
    firstMealCardsGrid.innerHTML = originalGridHTML;
    if (pagination) {
      pagination.style.display = '';
    }
    updateResultsCount('', 0);
  }

  function filterRenderedMeals(keyword) {
    let count = 0;
    const mealCards = firstMealCardsGrid.querySelectorAll('.meal-card-link');

    mealCards.forEach((card) => {
      const title = (card.getAttribute('data-title') || '').toLowerCase();
      const isMatch = title.includes(keyword);
      card.style.display = isMatch ? 'block' : 'none';
      if (isMatch) count++;
    });

    updateResultsCount(keyword, count);
  }

  async function filterCollectionMeals() {
    const keyword = searchInput.value.trim().toLowerCase();

    if (!keyword) {
      restorePaginatedResults();
      return;
    }

    if (!collectionHandle) {
      filterRenderedMeals(keyword);
      return;
    }

    resultsCount.textContent = `Searching for "${keyword}"...`;
    if (pagination) {
      pagination.style.display = 'none';
    }

    try {
      const products = await fetchCollectionProducts();
      if (searchInput.value.trim().toLowerCase() !== keyword) return;
      const matches = products.filter((product) => product.title.toLowerCase().includes(keyword));
      firstMealCardsGrid.innerHTML = matches.map(buildMealCard).join('');
      updateResultsCount(keyword, matches.length);
    } catch (error) {
      console.error(error);
      filterRenderedMeals(keyword);
    }
  }

  // Attach event listener to search input
  searchInput.addEventListener('input', filterCollectionMeals);
});
